/*turbo-ignore-versioning*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "turbo-ignore",
  "description": "了解如何使用 turbo-ignore 在 CI 中跳过任务。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "使用 turbo 确定包或其依赖是否有更改。这对于在 CI 中快速跳过任务非常有用。"
  }, {
    "heading": "",
    "content": "¥Use turbo to determine if a package or its dependencies have changes. This can be useful for quickly skipping tasks in CI."
  }, {
    "heading": "",
    "content": "要了解更多信息，请访问："
  }, {
    "heading": "",
    "content": "¥To learn more, visit:"
  }, {
    "heading": "",
    "content": "跳过任务的入门指南"
  }, {
    "heading": "",
    "content": "¥The introductory guide to skipping tasks"
  }, {
    "heading": "",
    "content": "跳过任务的高级指南"
  }, {
    "heading": "",
    "content": "¥The advanced guide for skipping tasks"
  }, {
    "heading": "",
    "content": "npm 上 turbo-ignore 的文档"
  }, {
    "heading": "",
    "content": "¥Documentation for turbo-ignore on npm"
  }, {
    "heading": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "¥turbo-ignore versioning"
  }, {
    "heading": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "由于 turbo-ignore 通常在将依赖安装到存储库之前使用，因此运行 turbo-ignore 时不会有可用的 turbo 二进制文件。turbo-ignore 将使用以下策略搜索与你的存储库一起使用的正确版本："
  }, {
    "heading": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "¥Because turbo-ignore is most often used before installing dependencies into the repository, there won't be a turbo binary available when you run turbo-ignore. Instead turbo-ignore will search for the correct version to use with your repository with the following strategy:"
  }, {
    "heading": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "首先，在根目录 package.json#devDependencies 或 package.json#dependencies 中检查 turbo 条目。如果在那里找到一个版本，它将被使用。"
  }, {
    "heading": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "¥First, check for a turbo entry in root package.json#devDependencies or package.json#dependencies. If a version is found there, it will be used."
  }, {
    "heading": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "如果在 package.json 中找不到 entry，则会读取 turbo.json 的架构。如果找到 tasks 键，则使用 turbo@^2。如果找到了 Turborepo v1 中的 pipeline，请使用 turbo@^1。"
  }, {
    "heading": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "¥If no entry is found in package.json, turbo.json will be read for its schema. If the tasks key is found, use turbo@^2. If the pipeline from Turborepo v1 is found, use turbo@^1."
  }],
  "headings": [{
    "id": "turbo-ignore-版本控制-turbo-ignore-versioning",
    "content": "turbo-ignore 版本控制 /*turbo-ignore-versioning*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#turbo-ignore-版本控制-turbo-ignore-versioning",
  title: _jsx(_Fragment, {
    children: "turbo-ignore 版本控制 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["使用 ", _jsx(_components.code, {
        children: "turbo"
      }), " 确定包或其依赖是否有更改。这对于在 CI 中快速跳过任务非常有用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use ", _jsx(_components.code, {
        children: "turbo"
      }), " to determine if a package or its dependencies have changes. This can be useful for quickly skipping tasks in CI."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo-ignore"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [workspace] [flags...]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "要了解更多信息，请访问："
    }), "\n", _jsx(_components.p, {
      children: "¥To learn more, visit:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/crafting-your-repository/constructing-ci#skipping-tasks-and-other-unnecessary-work",
            children: "跳过任务的入门指南"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/constructing-ci#skipping-tasks-and-other-unnecessary-work",
            children: "The introductory guide to skipping tasks"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/guides/skipping-tasks",
            children: "跳过任务的高级指南"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/guides/skipping-tasks",
            children: "The advanced guide for skipping tasks"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "https://www.npmjs.com/package/turbo-ignore",
            children: ["npm 上 ", _jsx(_components.code, {
              children: "turbo-ignore"
            }), " 的文档"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "https://www.npmjs.com/package/turbo-ignore",
            children: ["Documentation for ", _jsx(_components.code, {
              children: "turbo-ignore"
            }), " on npm"]
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "turbo-ignore-版本控制-turbo-ignore-versioning",
      children: "turbo-ignore 版本控制 "
    }), "\n", _jsx(_components.p, {
      children: "¥turbo-ignore versioning"
    }), "\n", _jsxs(_components.p, {
      children: ["由于 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " 通常在将依赖安装到存储库之前使用，因此运行 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " 时不会有可用的 ", _jsx(_components.code, {
        children: "turbo"
      }), " 二进制文件。", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " 将使用以下策略搜索与你的存储库一起使用的正确版本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Because ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " is most often used before installing dependencies into the repository, there won't be a ", _jsx(_components.code, {
        children: "turbo"
      }), " binary available when you run ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), ". Instead ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " will search for the correct version to use with your repository with the following strategy:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["首先，在根目录 ", _jsx(_components.code, {
            children: "package.json#devDependencies"
          }), " 或 ", _jsx(_components.code, {
            children: "package.json#dependencies"
          }), " 中检查 ", _jsx(_components.code, {
            children: "turbo"
          }), " 条目。如果在那里找到一个版本，它将被使用。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥First, check for a ", _jsx(_components.code, {
            children: "turbo"
          }), " entry in root ", _jsx(_components.code, {
            children: "package.json#devDependencies"
          }), " or ", _jsx(_components.code, {
            children: "package.json#dependencies"
          }), ". If a version is found there, it will be used."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果在 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中找不到 ", _jsx(_components.code, {
            children: "entry"
          }), "，则会读取 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 的架构。如果找到 ", _jsxs(_components.a, {
            href: "/docs/reference/configuration#tasks",
            children: [_jsx(_components.code, {
              children: "tasks"
            }), " 键"]
          }), "，则使用 ", _jsx(_components.code, {
            children: "turbo@^2"
          }), "。如果找到了 Turborepo v1 中的 ", _jsx(_components.code, {
            children: "pipeline"
          }), "，请使用 ", _jsx(_components.code, {
            children: "turbo@^1"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If no ", _jsx(_components.code, {
            children: "entry"
          }), " is found in ", _jsx(_components.code, {
            children: "package.json"
          }), ", ", _jsx(_components.code, {
            children: "turbo.json"
          }), " will be read for its schema. If ", _jsxs(_components.a, {
            href: "/docs/reference/configuration#tasks",
            children: ["the ", _jsx(_components.code, {
              children: "tasks"
            }), " key"]
          }), " is found, use ", _jsx(_components.code, {
            children: "turbo@^2"
          }), ". If the ", _jsx(_components.code, {
            children: "pipeline"
          }), " from Turborepo v1 is found, use ", _jsx(_components.code, {
            children: "turbo@^1"
          }), "."]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
